module.exports = __webpack_public_path__ + "img/star.e8c553ad.svg";